module.exports = __webpack_public_path__ + "img/tool-01.3c0d0483.png";